export const DEFAULT_VALUES = {
    // CARD_PAYMENT : 3.2,
    CARD_PAYMENT : 0,
    CUSTOMER_PHONE_NO: 1111111111,
    REPORT_FROM_TIME: '03:00:00',
    REPORT_TO_TIME: '02:59:59'
}